import {
    FETCH_ADMIN_USER_NEW_REQUEST,
    FETCH_ADMIN_USER_NEW_SUCCESS,
    FETCH_ADMIN_USER_NEW_FAILURE,
  } from "./actionTypes";
  
  import { AdminUserNewActions, AdminUserNewState } from "./types";
  
  const initialState: AdminUserNewState = {
    loading: false,
    result: null,
    error: null,
  };
  
  export default (state = initialState, action: AdminUserNewActions) => {
    switch (action.type) {
      case FETCH_ADMIN_USER_NEW_REQUEST:
        return {
          ...state,
          loading: true,
          error: null,
        };
      case FETCH_ADMIN_USER_NEW_SUCCESS:
        return {
          ...state,
          loading: false,
          result: action.payload.result,
          error: null,
        };
      case FETCH_ADMIN_USER_NEW_FAILURE:
        return {
          ...state,
          loading: false,
          result: [],
          error: action.payload.error,
        };
      default:
        return {
          ...state,
        };
    }
  };